import type { Uuid } from "spacetimedb";
import { FileTextIcon } from "lucide-react";
import { useState } from "react";

import type { LeaseConnection } from "@tycho/web-bindings/types";
import { UploadLeaseDocDrawer } from "@/web/routes/_protected/smb/-dashboard/-actions/UploadLeaseDocDrawer";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  underwritableEntity: Uuid;
  leases: LeaseConnection[];
};

function UploadLeaseDocCompleted({ underwritableEntity, leases }: Props) {
  const [open, setOpen] = useState(false);
  const title = leases.length === 1 ? "Lease uploaded" : `${leases.length} leases uploaded`;

  return (
    <>
      <CompletedActionCard
        category="negotiate"
        badge="Price"
        title={title}
        details={{
          title: "Lease documents",
          children: (
            <ul className="flex flex-col gap-2">
              {leases.map((lease) => (
                <li key={lease.id} className="flex items-start gap-2">
                  <FileTextIcon
                    className="size-4 shrink-0 translate-y-0.5 opacity-60"
                    aria-hidden
                  />
                  <span className="break-all">{lease.originalFileName}</span>
                </li>
              ))}
            </ul>
          ),
        }}
        action={{
          label: "Add more",
          onClick: () => setOpen(true),
        }}
      />
      <UploadLeaseDocDrawer
        open={open}
        onOpenChange={setOpen}
        underwritableEntity={underwritableEntity}
      />
    </>
  );
}

export function createUploadLeaseDocCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const {
    underwritableEntity,
    leases,
    id = `upload-lease-doc:done:${underwritableEntity.toString()}`,
  } = props;
  return {
    id,
    category: "negotiate",
    canSkip: false,
    render: () => (
      <UploadLeaseDocCompleted underwritableEntity={underwritableEntity} leases={leases} />
    ),
  };
}
